export const MitigationStatusList = [
  'DASHBOARD.MITIGATION_STATUS.SELF_VERIFIED',
  'DASHBOARD.MITIGATION_STATUS.ONGOING'
];
